import React, { createContext, useState } from 'react';
export const DataContext = createContext(null);